// extracted by mini-css-extract-plugin
export default {"container":"feedback_container__0Js-z"};